import { LabelColor } from '../configs/label-color';

export const colorMap = {
  [LabelColor.Grey]: 'bg-default-350 text-default-900 dark:text-dark-800 dark:bg-default-350/20',
  [LabelColor.Dark]: 'bg-default-900 text-default-50 dark:bg-dark-900 dark:text-default-900',
  [LabelColor.Slate]: 'bg-slate-300/50 text-slate-800 dark:text-slate-300 dark:bg-slate-400/20',
  [LabelColor.LightGreen]: 'bg-green-300/50 text-emerald-800 dark:text-emerald-300 dark:bg-green-400/20',
  [LabelColor.Emerald]: 'bg-emerald-300/50 text-emerald-800 dark:text-emerald-300 dark:bg-emerald-300/20',
  [LabelColor.LightBlue]: 'bg-sky-300/50 text-sky-800 dark:text-blue-300 dark:bg-blue-300/20',
  [LabelColor.Blue]: 'bg-blue-300/50 text-blue-800 dark:text-blue-300 dark:bg-blue-400/20',
  [LabelColor.Purple]: 'bg-blue-650/25 text-blue-750 dark:text-indigo-300 dark:bg-blue-650/25',
  [LabelColor.Cyan]: 'bg-cyan-300/40 text-cyan-800 dark:text-cyan-300 dark:bg-cyan-400/20',
  [LabelColor.Red]: 'bg-red-300/50 text-red-800 dark:text-red-300 dark:bg-red-300/20',
  [LabelColor.Orange]: 'bg-orange-300/50 text-orange-800 dark:bg-orange-400/20 dark:text-orange-300',
  [LabelColor.Amber]: 'bg-amber-300/50 text-amber-800 dark:bg-amber-400/20 dark:text-amber-300',
  [LabelColor.Fuchsia]: 'bg-fuchsia-300/50 text-fuchsia-800 dark:bg-fuchsia-400/20 dark:text-fuchsia-300',
  [LabelColor.Teal]: 'bg-teal-200/50 text-teal-800 dark:bg-teal-400/20 dark:text-teal-300',
  [LabelColor.Indigo]: 'bg-indigo-300/50 text-indigo-800 dark:bg-indigo-400/20 dark:text-indigo-300',
} satisfies { [key in LabelColor]: string };
